export default "assets/images/logo-icon-8f6a7517.svg";